import { Get, Post, Put } from 'utils/Request';
import { get } from 'utils/RequestV2';
import { getJarvis, putJarvis } from 'utils/RequestJarvis';
import API_CONSTANT from 'constants/apiConstant';
import { getRequest } from 'containers/CreditCardFlow/Services/RequestV2';
import { GetRequestForConsumer2 } from 'utils/consumerRequest';

export const ZetaCardLogoutTrigger = async (payload) =>
	Post('v1/' + API_CONSTANT.URL.ZETA_CARD_LOGOUT_TRIGGLER, payload);

export const ToggleUpdateLimitFlag = async (payload) => Post('v1' + API_CONSTANT.URL.UPDATE_LIMIT_FLAG, payload);

export const GetUpdatedLimit = async () => Get('v1' + API_CONSTANT.URL.UPDATE_LIMIT);

export const CcFeatureAccess = async () => get('v1' + API_CONSTANT.URL.ACCESS_FEATURE);

export const C1BannerAPI = async () => getJarvis('banners');

export const UpdateC1Banner = async (payload) => putJarvis(`banners`, payload);

export const getSanctionLetterData = async () => get('v1/' + 'sanction-letter/get/location');

export const GetEarnings = async () => Get('v1/' + API_CONSTANT.URL.CASHBACK_DETAILS);

export const GetHomeDetails = async () => Get('v1/' + API_CONSTANT.URL.HOME);

export const GetPersonalLoanLimit = async () => get(API_CONSTANT.URL.PL_LIMIT);

export const GetLoanCalculation = async (payload) => get(API_CONSTANT.URL.LOAN_CALCULATION, payload);

export const GetCCBPaymentDetails = async () => getRequest(API_CONSTANT.URL.CCBP_PENDING_ACTION_BANNER);
export const getMagicpinDetails = async (payload) => GetRequestForConsumer2('v1' + API_CONSTANT.ONDC.MAGICPIN, payload);

export const PostpeUserAPI = async () => Get('/postpe-user/v1');

export const DeletePostpeUserAPI = async () => Put('/postpe-user/v1/delete');
